import { combineReducers } from '@reduxjs/toolkit';

import user from './manage-customer/slices/user';
import module from './manage-module/slices/module';
import role from './manage-role/slices/role';
import log from './manage-log/slices/log';
import department from './manage-department/slices/department';

export default combineReducers({
  user,
  module,
  role,
  log,
  department,
});
